import { useEffect } from 'react';
import { MDSToastSnackbar } from '@marqvision/mds/core';

export const ErrorBoundaryView = () => {
  useEffect(() => {
    MDSToastSnackbar({
      type: 'error',
      title: 'Something went wrong!',
    });
  }, []);

  return <div></div>;
};
